<template>
    <TabView v-model:activeIndex="indexAtivo" @update:activeIndex="atualizarIndexAtivo">
        <TabPanel header="Geral">
            <Geral :convenio="convenio" />
        </TabPanel>
        <TabPanel header="Despesas">
            <Despesas :convenio="convenio" :carregarFiltro="carregarFiltroDespesas" />
        </TabPanel>
        <TabPanel header="Receitas">
            <Receitas :convenio="convenio" :carregarFiltro="carregarFiltroReceitas" />
        </TabPanel>
        <TabPanel header="Pretação de Contas">
            <PrestacaoContas :convenio="convenio" />
        </TabPanel>
    </TabView>
</template>

<script>
import Geral from './geral/Geral.vue';
import Despesas from './despesas/Despesas.vue';
import Receitas from './receitas/Receitas.vue';
import PrestacaoContas from './prestacaoContas/PrestacaoContas.vue';

export default {
    data() {
        return {
            indexAtivo: 0,
            carregarFiltroDespesas: false,
            carregarFiltroReceitas: false,
        };
    },

    methods: {
        atualizarIndexAtivo(novoIndex) {
            this.indexAtivo = novoIndex;
            if (novoIndex === 1) {
                // Despesas tab
                this.carregarFiltroDespesas = true;
                this.carregarFiltroReceitas = false;
            } else if (novoIndex === 2) {
                // Receitas tab
                this.carregarFiltroReceitas = true;
                this.carregarFiltroDespesas = false;
            } else {
                this.carregarFiltroDespesas = false;
                this.carregarFiltroReceitas = false;
            }
        },
    },

    props: {
        convenio: { type: Object },
    },

    components: {
        Geral,
        Despesas,
        Receitas,
        PrestacaoContas,
    },
};
</script>
